import React from 'react';
import { Target, TrendingUp, CheckCircle2, Wallet } from 'lucide-react';
import { howItWorks } from '../mockData';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  Target,
  TrendingUp,
  CheckCircle2,
  Wallet
};

const HowItWorks = () => {
  const { t } = useLanguage();
  
  return (
    <section id="how-it-works" style={{
      padding: '120px 24px',
      background: 'var(--bg-primary)',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '80px'
        }}>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 700,
            marginBottom: '16px',
            color: 'var(--text-primary)'
          }} className="display-md">
            {t('howItWorks.title')}
          </h2>
          <p style={{
            fontSize: '18px',
            color: 'var(--text-secondary)',
            maxWidth: '600px',
            margin: '0 auto'
          }} className="body-lg">
            {t('howItWorks.subtitle')}
          </p>
        </div>

        {/* Steps Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '32px',
          position: 'relative'
        }}>
          {/* Connection Line (Desktop) */}
          <div style={{
            position: 'absolute',
            top: '80px',
            left: '20%',
            right: '20%',
            height: '2px',
            background: 'linear-gradient(90deg, transparent, var(--border-primary) 20%, var(--border-primary) 80%, transparent)',
            zIndex: 0
          }} className="hidden lg:block" />

          {howItWorks.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.step} style={{
                position: 'relative',
                zIndex: 1
              }}>
                {/* Step Card */}
                <div style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-subtle)',
                  borderRadius: '20px',
                  padding: '40px 32px',
                  textAlign: 'center',
                  transition: 'all 0.3s ease',
                  height: '100%'
                }} className="card hover-lift">
                  {/* Step Number Badge */}
                  <div style={{
                    width: '64px',
                    height: '64px',
                    margin: '0 auto 24px',
                    background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, rgba(212, 175, 55, 0.05) 100%)',
                    border: '2px solid var(--accent-gold)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    fontWeight: 700,
                    color: 'var(--accent-gold)'
                  }}>
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div style={{
                    width: '56px',
                    height: '56px',
                    margin: '0 auto 24px',
                    background: 'rgba(14, 165, 233, 0.1)',
                    borderRadius: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--accent-blue)'
                  }}>
                    <IconComponent size={28} />
                  </div>

                  {/* Title */}
                  <h3 style={{
                    fontSize: '22px',
                    fontWeight: 600,
                    marginBottom: '16px',
                    color: 'var(--text-primary)'
                  }} className="h3">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p style={{
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: 'var(--text-muted)'
                  }} className="body-md">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div style={{
          textAlign: 'center',
          marginTop: '64px'
        }}>
          <p style={{
            fontSize: '18px',
            color: 'var(--text-secondary)',
            marginBottom: '24px'
          }} className="body-lg">
            Ready to get started?
          </p>
          <button
            onClick={() => window.location.href = '#plans'}
            className="btn-primary"
            style={{
              padding: '16px 40px',
              fontSize: '16px'
            }}
          >
            View Account Plans
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;